import React from 'react'
import { CompanyCredentials } from '@shared/components/company-credentials'

import { data } from './data'

import styles from './styles.module.scss'

export const View = () => {
	return (
		<article>
			<div className={styles.wrapper}>
				<div className={styles.contentWrapper}>
					<h3 className={styles.heading}>{data.heading}</h3>
					<div className={styles.content}>{data.content}</div>
					<ul className={styles.list}>
						{data.list.map((el: string) => {
							return (
								<li className={styles.listItem} key={el}>
									{el}
								</li>
							)
						})}
					</ul>
				</div>
				<CompanyCredentials />
			</div>
		</article>
	)
}
